import React, { useState, useEffect } from 'react';
import { Container, Button } from 'react-bootstrap';
import ChatBox from './components/ChatBox';
import SettingsModal from './components/settings/SettingsModal';

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    const storedMode = localStorage.getItem('darkMode');
    if (storedMode === 'true') setDarkMode(true);

    const savedSettings = JSON.parse(localStorage.getItem('groqSettings'));
    if (savedSettings) setSettings(savedSettings);
  }, []);

  useEffect(() => {
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  return (
    <div className={darkMode ? 'bg-dark text-light' : 'bg-light text-dark'} style={{ minHeight: '100vh' }}>
      <Container className="pt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3>دستیار بازنویسی آراد سرمایه</h3>
          <div className="d-flex gap-2">
            <Button variant="outline-secondary" onClick={() => setShowSettings(true)}>
              تنظیمات
            </Button>
            <Button variant={darkMode ? 'secondary' : 'dark'} onClick={() => setDarkMode(!darkMode)}>
              {darkMode ? 'Dark Mode' : 'Light Mode'}
            </Button>
          </div>
        </div>
        <ChatBox darkMode={darkMode} settings={settings} />
      </Container>

      <SettingsModal
        show={showSettings}
        handleClose={() => setShowSettings(false)}
        onSave={(newSettings) => setSettings(newSettings)}
      />
    </div>
  );
}

export default App;
